import { ViewModeType } from "../generated/interface"
import { Gesture, gestureLayers } from "./BaseGesture"

class CollectionViewFileDropOnFolderToMove extends Gesture {
  override layer = gestureLayers.mainView

  override reset() {
    this.switchMode("none")
  }

  override async onMouseUp(mouse: MouseEvent) {
    const { state: gestureState, isOverCollectionView } = useGestures()
    const { getColumnViewFolderFromEvent } = useGestures()
    const { state: viewModeState } = useViewMode()
    const { selectedFiles, clearSelected } = useSelection()
    const { moveFiles } = useFileSystem()
    const { currentRootFolder } = useNavigation()

    if (gestureState.value.gesture !== "drag-file")
      return

    const files = selectedFiles.value
    if (!len(files))
      return this.error("No selected files to drop")

    if (!isOverCollectionView(mouse))
      return

    let destination = currentRootFolder.value
    if (viewModeState.value.current.mode === ViewModeType.Column) {
      const folder = getColumnViewFolderFromEvent(mouse)
      if (folder)
        destination = folder
    }

    if (!destination)
      return this.error("Did not find a destination to drop into")

    this.debug("Dropped files on collection background", files, destination)
    this.capture()
    this.switchMode("none")
    moveFiles(files, destination)
    clearSelected()

    return

    // This means we're just dropping into the page itself. This
    // could mean we just want to cancel the drag, or that we are
    // dragging in a file from the sidebar, or another window/tab?
  }
}

export default function () {
  return new CollectionViewFileDropOnFolderToMove()
}
